'use client'

import { useState } from 'react'
import type { Location } from '@/lib/types/map'
import CtaDefault from './ui/cta/CtaDefault'
import GoogleMap from './GoogleMap'
import Icon from './svg/icon'
import Modal from '@/components/Modal'
import clsx from 'clsx'

type LocationCardProps = Location & { isDealerCard?: boolean }

export function LocationCard({
	id,
	type,
	dealer_name,
	address,
	contact_phone,
	contact_email,
	website,
	isDealerCard,
	latitude,
	longitude,
	zip,
	className,
}: LocationCardProps & { className?: string }) {
	const [location, setLocation] = useState<Location | null>(null)
	const [isMapModalOpen, setIsMapModalOpen] = useState(false)

	return (
		<div
			className={clsx('flex flex-col gap-2 bg-white rounded-lg px-4 py-8 lg:p-10', className)}
			key={id}
		>
			{dealer_name && <h3 className="text-2xl font-medium">{dealer_name}</h3>}
			{address && (
				<span className="mt-1 flex items-center gap-2">
					<Icon icon="LocationPinSimple" />
					{address}
				</span>
			)}
			{contact_phone && (
				<p className="mt-8">
					<span className="text-blue">Phone:</span>{' '}
					<a href={`tel:${contact_phone}`}>{contact_phone}</a>
				</p>
			)}
			{contact_email && (
				<p className="mb-4">
					<span className="text-blue">Email:</span>{' '}
					<a href={`mailto:${contact_email}`}>{contact_email}</a>
				</p>
			)}
			{website && (
				<CtaDefault
					className="w-full mt-auto"
					cta={{
						__typename: 'NavigationItemRecord',
						id,
						externalLink: website,
						label: 'Visit Website',
						useExternalLink: true,
						openInNewWindow: true,
					}}
				>
					Visit Website
				</CtaDefault>
			)}

			{isDealerCard && (
				<CtaDefault
					className={`cta w-full ${!website ? 'mt-auto' : ''}`}
					onClick={() => {
						setLocation({
							id,
							dealer_name,
							address,
							type,
							website,
							contact_phone,
							contact_email,
							latitude,
							longitude,
							zip,
						})
						setIsMapModalOpen(true)
					}}
				>
					Get Directions
				</CtaDefault>
			)}

			<Modal isOpen={isMapModalOpen} onClose={() => setIsMapModalOpen(false)}>
				{location && <GoogleMap locations={[location]} />}
			</Modal>
		</div>
	)
}
